import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { LoadingSkeletonDirective2 } from 'common-ui';
import { ItemId } from 'products-data';
import { ItemResultLayoutComponent } from '../item-result-layout';

@Component({
  selector: 'ideal-item-result-list',
  imports: [ItemResultLayoutComponent, LoadingSkeletonDirective2],
  standalone: true,
  templateUrl: './item-result-list.component.html',
  styleUrl: './item-result-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ItemResultListComponent {
  public readonly ids = input<(ItemId | null)[]>([]);
}
